import { baseRoute } from "config/const";
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { sendDeeplinkClickGa } from "tracking";

function buildRedirectPath(params, target) {
  params.delete("target");
  const search = params.toString();
  return `${target}${search ? `?${search}` : ""}`;
}

function isRootWithoutLiffState() {
  return (
    window.location.pathname === "/" &&
    !window.location.href.includes("liff.state")
  );
}

export default function LandingPage() {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleRedirect = async () => {
      try {
        const params = new URLSearchParams(location.search);
        const target = params.get("target");
        const from = params.get("from") || "";

        if (from) {
          sendDeeplinkClickGa("anonymous", from, target);
          // wait for 800ms to ensure the event is sent
          await new Promise((resolve) => setTimeout(resolve, 800));
        }

        if (target) {
          navigate(buildRedirectPath(params, target), { replace: true });
          return;
        }

        if (isRootWithoutLiffState()) {
          navigate(`${baseRoute}/home`, { replace: true });
        }
      } catch (error) {
        console.error("[LandingPage] Failed to handle redirect:", error);
      }
    };

    handleRedirect();
  }, [location, navigate]);

  return <div />;
}
